import type { Resource } from '../../';
export const forms_error_onlyLetters: Resource = {"default":"The {name} field must contain only letters."};
